// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1hUth","resendInfoText":"OnGoingPaymentBox_resendInfoText__AHPCC"};